import { render, staticRenderFns } from "./CreateActionInstructions.vue?vue&type=template&id=20950796&lang=pug"
import script from "./CreateActionInstructions.vue?vue&type=script&lang=js"
export * from "./CreateActionInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports